module.exports = __webpack_public_path__ + "img/banner5.a5dbc0ad.png";